// extracted by mini-css-extract-plugin
module.exports = {"scrolled":"Navbar_scrolled__1-XDa","active":"Navbar_active__1hqgn"};